// import Bridge from './lib/Bridge'
import BridgeV2 from "./lib/BridgeV2";

export default BridgeV2;
export { BridgeV2 };
